/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteFirmwaresRequest
 */
export interface DeleteFirmwaresRequest {
    /**
     * ids of firmwares that should be deleted
     * @type {Array<string>}
     * @memberof DeleteFirmwaresRequest
     */
    firmwareIds?: Array<string>;
}

export function DeleteFirmwaresRequestFromJSON(json: any): DeleteFirmwaresRequest {
    return DeleteFirmwaresRequestFromJSONTyped(json, false);
}

export function DeleteFirmwaresRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFirmwaresRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firmwareIds': !exists(json, 'firmwareIds') ? undefined : json['firmwareIds'],
    };
}

export function DeleteFirmwaresRequestToJSON(value?: DeleteFirmwaresRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firmwareIds': value.firmwareIds,
    };
}

